import { useCallback } from "react";
import { Navigate, useSearchParams } from "react-router";
import FullScreenLoader from "@entrilia/shared/components/fullScreenLoader/FullScreenLoader";
import useFetch from "@entrilia/shared/hooks/useFetch";
import { logError } from "@entrilia/shared/logging";
import adminApi from "../../../api/adminApi";
import useClientContext from "../../../context/useClientContext";
import useHideLeftSideRootMenu from "../../../hooks/useHideLeftSideRootMenu";
import { getFundOpsBusinessCentralRedirectUrl } from "../../../utilities/navigationHelper";

const FundOpsTransactionLinkPage = () => {
  const [searchParams] = useSearchParams();
  const { clientCode } = useClientContext();

  useHideLeftSideRootMenu();

  const no = searchParams.get("no");

  const resolveLink = useCallback(() => adminApi.resolveFundOpsTransactionLink(no ?? ""), [no]);

  const [resp, err] = useFetch(resolveLink, { disabled: !no });

  if (!no) {
    return <Navigate to={`/${clientCode}`} />;
  }

  if (err) {
    logError(err, "[FundOpsTransactionLinkPage] resolveFundOpsTransactionLink");
    return <Navigate to={`/${clientCode}`} />;
  }

  if (resp?.resolvedUrl) {
    return <Navigate to={getFundOpsBusinessCentralRedirectUrl(clientCode, resp.resolvedUrl)} replace />;
  }

  return <FullScreenLoader title="Please wait" subtitle="You are being redirected to Fund Operations..." />;
};

export default FundOpsTransactionLinkPage;
